import { useEffect, useState } from "react";
import { useGetApi } from "src/hooks";

import { flattenInfoList } from "./Chart.utils";

type TDescriptions = Record<string, string>;

const cache = new Map<string, TDescriptions>();

const mapInfoList = (result: any) => flattenInfoList(result?.data?.ildata);

export const useCodeDescriptions = (ilIds: string[]) => {
  const [byList, setByList] = useState<Record<string, TDescriptions>>({});
  const { refetch } = useGetApi<TDescriptions>({
    request: "get-info-list",
    fetchOnInit: false,
    notifyError: false,
    mapper: mapInfoList,
  });
  const key = JSON.stringify(ilIds);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      const next: Record<string, TDescriptions> = {};
      for (const ilid of JSON.parse(key) as string[]) {
        if (!cache.has(ilid)) {
          const descriptions = await refetch({ params: { ilid } });
          if (descriptions) cache.set(ilid, descriptions);
        }
        const cached = cache.get(ilid);
        if (cached) next[ilid] = cached;
      }
      if (!cancelled) setByList(next);
    })();
    return () => {
      cancelled = true;
    };
  }, [key, refetch]);

  return byList;
};
